import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import CommercialDemo from "./components/CommercialDemo/CommercialDemo";
import './index.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
const isLocalhostRuntime =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);
const isCommercialDemoRoute =
  typeof window !== "undefined" &&
  isLocalhostRuntime &&
  new URLSearchParams(window.location.search).get("commercialDemo") === "1";

root.render(
  isLocalhostRuntime && isCommercialDemoRoute ? (
    <CommercialDemo />
  ) : (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  )
);

if ("serviceWorker" in navigator && window.isSecureContext) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((error) => {
        if (process.env.NODE_ENV !== "production") {
          console.warn("Service worker registration failed:", error);
        }
      });
  });
}
